module.exports = __webpack_public_path__ + "img/image-3.8102a999.jpg";